module.exports = __webpack_public_path__ + "img/LS.2e72955d.png";